import { getAuth } from 'firebase/auth';

function withAuthorization(headers, token) {
    const nextHeaders = new Headers(headers ?? {});
    nextHeaders.set('Authorization', `Bearer ${token}`);
    return nextHeaders;
}

async function readIdToken(forceRefresh = false) {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
        throw new Error('Missing authenticated user');
    }

    return currentUser.getIdToken(forceRefresh);
}

export async function authFetch(input, init = {}) {
    const token = await readIdToken();
    let response = await fetch(input, {
        ...init,
        headers: withAuthorization(init.headers, token),
    });

    if (response.status === 401 || response.status === 403) {
        const refreshedToken = await readIdToken(true);
        response = await fetch(input, {
            ...init,
            headers: withAuthorization(init.headers, refreshedToken),
        });
    }

    return response;
}
